import React from 'react'
import CookieConsent, { Cookies } from 'react-cookie-consent'
import { Wrapper, Content, ButtonClose } from './index.styled'

const COOKIE_NAME = 'echelon-cookie-consent'
const COOKIE_EXPIRES = 150

const CookiesBanner = () => {
  const ref = React.useRef()

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      ref?.current?.classList?.add('show')
    }, 4500)
    return () => clearTimeout(timeout)
  }, [])

  // Closing counts as consent ("By closing this pop-up window you consent..."),
  // so persist it like Accept so the banner doesn't reappear.
  const onClose = () => {
    Cookies.set(COOKIE_NAME, 'true', { expires: COOKIE_EXPIRES })
    ref?.current?.classList?.remove('show')
  }

  // Layout mounts this outside the ScrollSmoother wrapper, so position:fixed
  // pins to the viewport. CookieConsent renders nothing until mount — SSR-safe.
  return (
    <Wrapper ref={ref}>
      <CookieConsent
        location='none'
        cookieName={COOKIE_NAME}
        buttonText='Accept All'
        disableStyles
        containerClasses='cookies-banner'
        buttonClasses='cookies-banner-accept-btn'
        disableButtonStyles
        buttonWrapperClasses='cookies-banner-btns'
        contentClasses='cookies-banner-content'
        expires={COOKIE_EXPIRES}
      >
        <Content>
          To provide you with a better experience, this site uses cookies. By closing this pop-up window you consent to the use of cookies.
        </Content>
        <ButtonClose onClick={onClose} />
      </CookieConsent>
    </Wrapper>
  )
}

export default CookiesBanner
